import { render } from "./member-status-icon.vue?vue&type=template&id=d72a9528&lang=pug"
import script from "./member-status-icon.vue?vue&type=script&lang=js"
export * from "./member-status-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__